// useRouting.js
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { clientData } from "./GetClient";

export function useRoutingByType(type) {
  return useMemo(() => {
    if (!type || !clientData?.route_manage) return `/${type}`;
    const { routes } = clientData.route_manage;
    const normalizedType = type === "blog" ? "blogs" : type === "portfolio" ? "portfolios" : type;

    // No route name override → use original type
    if (!routes?.length) return `/${type}`;

    const typeToName = Object.fromEntries(routes.map((r) => [r.type, r.name]));
    const routeName = typeToName[normalizedType];

    // No matching route → fallback
    if (!routeName) return `/${type}`;

    return `/${routeName}`;
  }, [type, clientData?.route_manage]);
}
